import { Select } from '@lune-fe/lune-ui-lib'

import { AutoFillComponentState } from 'views/CalculateEmissions/RFQ/utils/types'

type UnitPickerProps<T> = {
    units: readonly T[]
    formatUnit: (unit: T) => string
    selectedUnit: T
    onUpdate: (unit: T) => void
    autoFill?: AutoFillComponentState
}

const UnitPicker = <T,>({
    units,
    formatUnit,
    selectedUnit,
    onUpdate,
    autoFill,
}: UnitPickerProps<T>) => {
    const handleChange = (value: string) => {
        const index = Number(value)
        onUpdate(units[index])
    }

    return (
        <Select
            sx={{
                minWidth: '95px',
                ...(autoFill?.value && {
                    backgroundColor: 'Blue50',
                    '&:hover': {
                        backgroundColor: 'Blue100',
                    },
                }),
            }}
            onClose={() => autoFill?.update(false)}
            onChange={handleChange}
            value={units.indexOf(selectedUnit).toString()}
            items={units.map((i, index) => ({ label: formatUnit(i), value: index.toString() }))}
        />
    )
}

export default UnitPicker
